import React, { useCallback } from 'react';
import { styled } from '@linaria/react';
import { AnimatePresence, motion } from 'framer-motion';
import { Button } from '../../Button';
import { Icon as AtlasIcon } from '../../Icon';
const _exp = /*#__PURE__*/() => motion.div;
const Wrapper = /*#__PURE__*/styled(_exp())({
  name: "Wrapper",
  class: "w14qo90j",
  propsAsIs: true
});
const _exp3 = /*#__PURE__*/() => AtlasIcon;
const Icon = /*#__PURE__*/styled(_exp3())({
  name: "Icon",
  class: "i15izukn",
  propsAsIs: true
});
interface Props {
  currentIndex: number;
  totalPages: number;
  goToPane: (i: number) => void;
  showPaginationButtons: boolean;
}
export const PaginationButtons = ({
  showPaginationButtons,
  currentIndex,
  goToPane,
  totalPages
}: Props) => {
  const goToPrevPage = useCallback((e: React.SyntheticEvent) => {
    e.stopPropagation();
    goToPane(currentIndex > 0 ? currentIndex - 1 : totalPages - 1);
  }, [currentIndex, goToPane, totalPages]);
  const goToNextPage = useCallback((e: React.SyntheticEvent) => {
    e.stopPropagation();
    goToPane(currentIndex < totalPages - 1 ? currentIndex + 1 : 0);
  }, [currentIndex, goToPane, totalPages]);
  if (totalPages < 2) return null;
  return <AnimatePresence>
      {showPaginationButtons && <Wrapper initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }}>
          <Button dataId="paginationLeftButton" iconStart={<Icon name="ChevronLeft" />} size="sm" variant="secondary" isFloating isRounded onClick={goToPrevPage} />

          <Button dataId="paginationRightButton" iconStart={<Icon name="ChevronRight" />} size="sm" variant="secondary" isFloating isRounded onClick={goToNextPage} />
        </Wrapper>}
    </AnimatePresence>;
};

require("./PaginationButtons.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./PaginationButtons.tsx");